module.exports = {
      id: "longform-usage",
      viewBox: "0 0 12.6 15.258",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#longform",
      toString: function () {
        return this.url;
      }
    }